import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import {
    FETCH_USER_SETTINGS,
    FETCH_USER_SETTINGS_FETCHING,
    FETCH_USER_SETTINGS_SUCCESS,
    FETCH_USER_SETTINGS_FAIL,
    UPDATE_USER_SETTINGS,
    UPDATE_USER_SETTINGS_UPDATING,
    UPDATE_USER_SETTINGS_SUCCESS,
    UPDATE_USER_SETTINGS_ERROR,
    UPDATE_USER_SETTINGS_MCT,
    UPDATE_USER_SETTINGS_MCT_SUCCESS,
    UPDATE_USER_SETTINGS_MCT_ERROR,
    FETCH_USER_SETTINGS_DSW,
    FETCH_USER_SETTINGS_DSW_FETCHING,
    FETCH_USER_SETTINGS_DSW_SUCCESS,
    FETCH_USER_SETTINGS_DSW_FAIL,
    UPDATE_USER_SETTINGS_DSW,
    UPDATE_USER_SETTINGS_DSW_UPDATING,
    UPDATE_USER_SETTINGS_DSW_SUCCESS,
    UPDATE_USER_SETTINGS_DSW_ERROR
} from '../actions/ActionTypes';

import { handlingSuccessCallback, handlingErrorCallback } from './sagasUtils';

// worker
export function* fetchUserSettings(action) {
    const { callback } = action;

    try {
        yield put({
            type: FETCH_USER_SETTINGS_FETCHING
        });

        const response = yield call(gcApi.get, `/userprofile-service/userprofile/user-settings/`);

        yield put({
            type: FETCH_USER_SETTINGS_SUCCESS,
            userSettings: response.data
        });

        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield put({
            type: FETCH_USER_SETTINGS_FAIL,
            userSettings: {}
        });
    }
}

// Updates the userData object in the userSettings data
export function* updateUserSettings(action) {
    try {
        yield put({
            type: UPDATE_USER_SETTINGS_UPDATING
        });

        yield call(gcApi.put, `/userprofile-service/userprofile/user-settings/`, {
            userData: action.payload
        });

        yield put({
            type: UPDATE_USER_SETTINGS_SUCCESS,
            userSettings: action.payload
        });
        if (action.payload.callback) {
            yield call(handlingSuccessCallback, action.payload.callback, true);
        }
    } catch (e) {
        yield put({
            type: UPDATE_USER_SETTINGS_ERROR,
            userSettings: null
        });
        if (action.payload.callback) {
            yield call(handlingErrorCallback, action.payload.callback, false);
        }
    }
}

// Updates the userMenstrualCycleSettings object in the userSettings data
export function* updateUserSettingsMct(action) {
    try {
        yield put({
            type: UPDATE_USER_SETTINGS_UPDATING
        });

        yield call(gcApi.put, `/userprofile-service/userprofile/user-settings/`, {
            userMenstrualCycleSettings: action.payload
        });

        yield put({
            type: UPDATE_USER_SETTINGS_MCT_SUCCESS,
            userMenstrualCycleSettings: action.payload
        });
    } catch (e) {
        yield put({
            type: UPDATE_USER_SETTINGS_MCT_ERROR,
            userMenstrualCycleSettings: null
        });
    }
}

export function* fetchDSWWorkoutTargetTypes() {
    try {
        yield put({
            type: FETCH_USER_SETTINGS_DSW_FETCHING
        });

        const response = yield call(gcApi.get, '/userprofile-service/userprofile/adaptive-coaching-workouts');

        yield put({
            type: FETCH_USER_SETTINGS_DSW_SUCCESS,
            dswWorkoutTargetTypes: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_SETTINGS_DSW_FAIL
        });
    }
}

export function* updateDSWWorkoutTargetTypes(payload) {
    const { userProfilePk, sport, adaptiveCoachingWorkoutType } = payload;

    try {
        yield put({
            type: UPDATE_USER_SETTINGS_DSW_UPDATING
        });

        const response = yield call(gcApi.put, '/userprofile-service/userprofile/adaptive-coaching-workouts', {
            userProfilePk,
            sport,
            adaptiveCoachingWorkoutType
        });

        yield put({
            type: UPDATE_USER_SETTINGS_DSW_SUCCESS,
            dswWorkoutTargetType: response.data
        });
    } catch (e) {
        yield put({
            type: UPDATE_USER_SETTINGS_DSW_ERROR
        });
    }
}

// watcher
export const userSettingsSagas = [
    takeEvery(FETCH_USER_SETTINGS, fetchUserSettings),
    takeEvery(UPDATE_USER_SETTINGS, updateUserSettings),
    takeEvery(UPDATE_USER_SETTINGS_MCT, updateUserSettingsMct),
    takeEvery(FETCH_USER_SETTINGS_DSW, fetchDSWWorkoutTargetTypes),
    takeEvery(UPDATE_USER_SETTINGS_DSW, updateDSWWorkoutTargetTypes)
];
